<template>
  <div class="row" v-if="productCategories != null">
    <div class="col-md-12">
      <fieldset :disabled="pageType === 'view'">
        <div class="widget fluid">
          <div class="whead">
            <h6>Basic Info</h6>
          </div>
          <div class="card-body card-block">
            <form action method="post" enctype="multipart/form-data" class="form-horizontal">
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="part_no" class="form-control-label" v-required>Part No</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="part_no"
                    name="part_no"
                    placeholder
                    class="form-control"
                    v-model="input.part_no"
                    @keyup="checkPartNoExists()"
                    @blur="checkPartNoExists()"
                    ref="part_no"
                  >
                  <small class="text-danger" v-if="partNoExists">This part no already exists</small>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="product_category_id" class="form-control-label" v-required>Category</label>
                </div>
                <div class="col-12 col-md-9">
                  <model-select :options="productCategoryOptions"
                    v-model="input.product_category_id"
                    placeholder="Select Category"
                    :isDisabled="pageType === 'view'"  
                  >
                  </model-select>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3 d-flex align-items-center">
                  <label for="vendor_project_id" class="form-control-label" v-required>Vendor Project (Ref No)</label>
                </div>
                <div class="col-12 col-md-9">
                  <div class="row">
                    <div class="col col-md-3">
                      <model-select :options="vendorsOptions"
                        v-model="vendor_id"
                        placeholder="Select Vendor"
                        :isDisabled="pageType === 'view'"  
                      >
                      </model-select>
                    </div>
                    <div class="col col-md-9">
                      <model-select :options="vendorProjectsOptions"
                        v-model="input.vendor_project_id"
                        placeholder="Select Ref No"
                        :isDisabled="pageType === 'view' || gettingVendorProject"  
                      >
                      </model-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="status" class="form-control-label" v-required>Status</label>
                </div>
                <div class="col-12 col-md-9">
                  <select id="status" v-model="input.status" class="form-control" :disabled="pageType === 'view'">
                    <option value="">-</option>
                    <option value="Ordered">Ordered</option>
                    <option value="Standard">Standard</option>
                    <option value="Both">Both</option>
                    <option value="N/A">N/A</option>
                  </select>
                </div>
              </div>
              <h5>Product Specification</h5>
              <div class="row form-group" v-for="(item, key) in productSpecification" :key="key">
                <div class="col col-md-3 d-flex align-items-center">
                  <label
                    :for="'structure_' + item.id"
                    class="form-control-label"
                  >{{ item.field_name.en }}</label>
                </div>
                <div class="col-12 col-md-9">
                  <input type="text" placeholder class="form-control" v-model="input.productDatas[item.id].field_value">
                </div>
              </div>
            </form>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</template>
<script>

import { ModelSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

import save from 'src/global/save.js'
import back from 'src/global/back.js'
import getData from 'src/global/getData.js'
import createItem from 'src/global/createItem.js'
import updateItem from 'src/global/updateItem.js'
import validation from 'src/global/validation.js'

import ProductModel from './model/Product'

export default {
  components: {
    ModelSelect
  },
  data() {
    return {
      pageSettings: {
        pageTitle: 'Product',
        sectionName: 'product',
        sectionIcon: 'fas fa-glass',
        type: this.pageType,
        useDefault: true,
        webService: this.$root.WebService.product,
        modelID: this.$route.params.id ? this.$route.params.id : null,
        navigation: [
          { name: 'Product', route: 'product.index' },
          { name: this.$options.filters.capitalize(this.pageType) },
        ],
        buttons: [
          (this.pageType !== 'view' ? { name: 'Save', icon: 'fas fa-save', action: this.save } : null),
          { name: 'Back', icon: 'fas fa-arrow-left', action: this.back },
        ],
      },
      input: ProductModel(),
      requiredInput: [
        {key: 'part_no', title: 'Part No'},
        {key: 'product_category_id', title: 'Category'},
        {key: 'vendor_project_id', title: 'Vendor Project'},
      ],

      productCategories: null,
      productCategoryOptions: [],

      vendors: null,
      vendorsOptions: [],

      gettingVendorProject: false,
      vendorProjects: null,
      vendorProjectsOptions: [],
      
      modelID: this.$route.params.id ? this.$route.params.id : null,
      partNoExists: false,
      processing: false,

      firstLoad: true,
    }
  },
  props: {
    pageType: String
  },
  computed: {
    productSpecification() {
      if( this.productCategories !== null ) { 
        let item = this.productCategories.find(item => item.id == this.input.product_category_id)
        if( item )
          return item.structure
      }
    },
    productCategoryId() {
      return this.input.product_category_id
    },
    vendor_id: {
      get: function () {
        return this.input.vendor_id
      },
      set: function (value) {
        this.input.vendor_id = value
      }
    }
  },
  watch: {
    vendor_id: {
      immediate: false,
      handler(newVal, oldVal) {
        if( !this.firstLoad )
          this.input.vendor_project_id = null
        this.getVendorProject(newVal)
        this.firstLoad = false
      }
    },
    productCategoryId: {
      immediate: true,
      handler() {
        if( this.productCategories !== null ) { 
          let item = this.productCategories.find(item => item.id == this.input.product_category_id)
          if( item ) {
            let datas = {}
            item.structure.forEach(element => {

              let field_value = null
              let field = this.input.datas.find(i => i.product_structure_id == element.id)
              if( field )
                field_value = field.field_value

              datas[element.id] = {
                id: null,
                product_structure_id: element.id,
                product_id: this.modelID,
                field_value: field_value,
                created_at: null,
                updated_at: null,
              }
            })
            this.input.productDatas = datas
          }
        }
      }
    }
  },
  created() {
    this.getProductCategory()
    this.getVendor()
    //this.getVendorProject()
  },
  mounted() {
    this.$emit('setPageHeader', this.pageSettings)
  },
  methods: {
    getVendor() {
      this.$http
        .get(this.WebService.vendor + '?enabled=1')
        .then((response) => {
          this.vendors = response.data.data

          this.vendorsOptions = [{
            value: null,
            text: '-'
          }]
          

          this.vendors.forEach(element => {
            this.vendorsOptions.push({
              value: element.id,
              text: element.short_name
            })
          })

          this.getData()
          
        })
        .catch(null)
        .finally(null)
    },
    getVendorProject(vendor) {

      this.gettingVendorProject = true

      let url = this.WebService.vendorproject + '?for_product=1'
      if( this.modelID )
        url += '&product_id=' + this.modelID

      if( vendor )
        url += '&vendor_id=' + vendor

      this.vendorProjectsOptions = [{
          value: null,
          text: '-'
        }]

      this.$http
        .get(url)
        .then((response) => {
          this.vendorProjects = response.data.data

          this.vendorProjects.forEach(element => {
            this.vendorProjectsOptions.push({
              value: element.id,
              text: element.ref_no
            })
          })

          this.gettingVendorProject = false

        })
        .catch((err) => {

        })
        .finally(null)
    },
    getProductCategory() {
      this.$http
        .get(this.WebService.productCategory)
        .then((response) => {
          this.productCategories = response.data.data

          this.productCategoryOptions = []

          this.productCategories.forEach(element => {
            this.productCategoryOptions.push({
              value: element.id,
              text: element.name
            })
          })

        })
        .catch((err) => {

        })
        .finally(null)
    },
    checkPartNoExists(e) {
      return
      if( this.input.part_no ) {
        this.$http
          .post(this.WebService.product + '/checkPartNoExists', {
            part_no: this.input.part_no,
            id: this.modelID
          })
          .then((response) => {
            if (response.data > 0) {
              this.partNoExists = true
              this.$refs.model.focus()
            } else {
              this.partNoExists = false
            }
          })
          .catch((err) => {

          })
          .finally()
      }
    },
    back() {
      this.$router.go(-1)
    },
    save,
    getData,
    createItem,
    updateItem,
    validation,
    afterSaveSuccess(res) {
      this.$router.push({ name: this.pageSettings.sectionName + '.index', params: { id: res.data.data.product_category_id }})
    }
  }
}
</script>